import React from 'react';
import {DataGrid, IconMenu, SearchField, FilterMenu, Text, RaymanUser} from 'components/core';
import {Grid} from '@material-ui/core';
import {UsersCtx} from 'components/dataProviders/users';
import {OrganizationCtx} from 'components/dataProviders/organization';
import {makeStyles} from '@material-ui/core/styles';
import UserDialog from './dialog';
import {SupervisedUserCircle} from '@material-ui/icons';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)'
    },
    searchbox: {
        height: 40,
        width: 300
    },
    usersIcon:
    {
        color: theme.palette.text.primary,
        marginRight: 6,
        fontSize: 24,
        verticalAlign: 'middle',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    userCountLabel:
    {
        marginRight: 'auto',
        marginLeft: 30
    }
  }), {name: "RaymanDataGrid"});

  
const columns = {
    name: { 
        field: 'user',
        headerName: 'Usuario',
        flex: 1,
        renderCell: (params) => {
            return <>
                <RaymanUser userID={params.row.userID} label={params.row.email}/>
            </>
        }
    },
    profile: {
        field: 'profiles',
        headerName: "Perfiles",
        width: 200,
        flex: 1,
        renderCell: (params) => {
            if(params.row.profiles.length > 0)
            {
                return params.row.profiles.map((profile) => {
                switch(profile)
                {
                    case "administrators": return "Administrador";
                    case "experts": return "Experto";
                    case "operators": return "Operario";
                    default: return "";
                }
            }).join(", ");
            }
            else return "Sin perfiles";
        }
    }
}

function RowMenu({row, dataset})
{
    const ctx = React.useContext(UsersCtx);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    let items = [{
        label: "Editar",
        onClick: () => handleOpen()
    }];
    if(dataset === "open")
    {
        items.push({
            label: "Desactivar",
            onClick: () => {ctx.funcs.disable(row.userID)},
            danger: true
        });
    }
    else
    {
        items.push({
            label: "Reactivar",
            onClick: () => {ctx.funcs.enable(row.userID)}
        });
    }
    return <>
    <IconMenu items={items} />
    <UserDialog
    open={open}
    onClose={handleClose}
    userID={row.userID}
    />
    </>
}

export default function UsersList({dataset="open", onRowSelected})
{
    
    const ctx = React.useContext(UsersCtx);
    const orgCtx = React.useContext(OrganizationCtx);
    const [data, setData] = React.useState(ctx.data.array);
    const [filters, setFilters] = React.useState({text: '', profiles: []});
    const classes = useStyles();

    let searchTimeout = 0;

    const gridColumns = [columns.name, columns.profile, {
        field: 'menu',
        headerName: ' ',
        width: 300,
        align: 'left',
        sortable: false,
        renderCell: (params) => {
            return <RowMenu row={params.row} dataset={dataset} />
        }
    }];

    React.useEffect(function filterData(){
        let tmpData = [...ctx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.profiles.length > 0) result &= value.profiles.some(r => filters.profiles.includes(r));
            result &= (value.disabled === (dataset === "closed"));
            return result;
        });
        setData(tmpData);
        
    }, [ctx, dataset, filters]);

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleProfilesChange = React.useCallback((index) => {
        let tmpFilters = {...filters};
        tmpFilters.profiles = index.map(profile => {
            switch(profile)
            {
                case 0: return "administrators";
                case 1: return "experts";
                case 2: return "operators";
                default: return "¯\\_(ツ)_/¯";
            }
        });
        if(tmpFilters.profiles.join(",") !== filters.profiles.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);
    
    return <>
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item className={classes.userCountLabel}><Text><SupervisedUserCircle className={classes.usersIcon}/>{ctx.data.activeCount}/{orgCtx.data.userLimit} usuarios activos</Text></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Perfiles"} items={["Administradores", "Expertos", "Operarios"]} onChange={handleProfilesChange}/></Grid>
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        loading={ctx.loading}
        onRowSelected = {(row) => onRowSelected(row.data)}
        density="comfortable"
        className={classes.datagrid}
        />
    </>
}